import React from "react";

export const ExplanationEs = () => {
  return (
    <>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Esquema Ponzi Explicado</h2>
      <p className="text-gray-700 mb-4">
        Un <strong>esquema Ponzi</strong> es un tipo de fraude financiero que promete altos rendimientos a los inversores, pero en realidad paga los rendimientos utilizando fondos de nuevos inversores en lugar de ganancias legítimas. Así es como funciona paso a paso:
      </p>

      <h3><strong>Paso 1: Se Crea el Esquema</strong></h3>
      <ul>
        <li>Una persona o empresa promociona una oportunidad de inversión, prometiendo <strong>altos rendimientos con poco o ningún riesgo</strong>.</li>
        <li>Pueden afirmar utilizar <strong>estrategias de trading especiales, bienes raíces o criptomonedas</strong> para generar ganancias.</li>
      </ul>
      <h3 className="mt-2"><strong>Paso 2: Se Paga a los Inversores Iniciales</strong></h3>
      <ul>
        <li>Los inversores iniciales aportan dinero.</li>
        <li>En lugar de hacer inversiones legítimas, el organizador <strong>paga "rendimientos" a los inversores anteriores</strong> utilizando el dinero de nuevos inversores.</li>
        <li>Esto crea <strong>confianza y entusiasmo</strong>, animando a los inversores iniciales a <strong>reinvertir</strong> y reclutar a otros.</li>
      </ul>

      <h3 className="mt-2"><strong>Paso 3: Se Unen Más Inversores</strong></h3>
      <ul>
        <li>La noticia se difunde, y más personas <strong>invierten</strong>, creyendo que es una oportunidad rentable.</li>
        <li>El esquema crece a medida que entra nuevo dinero, permitiendo al organizador seguir pagando a los inversores antiguos y mantener la ilusión de éxito.</li>
      </ul>
      <h3 className="mt-2"><strong>Paso 4: El Esquema Se Vuelve Insostenible</strong></h3>
      <ul>
        <li>A medida que más personas se unen, se requieren <strong>pagos más grandes</strong>.</li>
        <li>En algún momento, <strong>las nuevas inversiones disminuyen</strong>, pero los inversores existentes aún esperan sus rendimientos.</li>
        <li>Como no hay <strong>ganancias reales</strong>, el organizador tiene dificultades para pagar los rendimientos.</li>
      </ul>
      <h3 className="mt-2"><strong>Paso 5: El Colapso</strong></h3>
      <ul>
        <li>Cuando el organizador <strong>no puede atraer suficientes nuevos inversores</strong>, <strong>no logra pagar los rendimientos prometidos</strong>.</li>
        <li>Los inversores <strong>entran en pánico e intentan retirar</strong> su dinero, pero el organizador <strong>no puede pagar</strong>.</li>
        <li>El esquema <strong>colapsa</strong>, y el organizador o bien <strong>desaparece con los fondos restantes</strong> o es atrapado.</li>
      </ul>
      <h3 className="mt-2"><strong>Señales Clave de un Esquema Ponzi</strong></h3>
      <ul>
        <li>1. Rendimientos altos garantizados sin riesgo</li>
        <li>2. Rendimientos consistentes a pesar de las condiciones del mercado</li>
        <li>3. Estrategias de inversión complejas o secretas</li>
        <li>4. Dificultad para retirar fondos</li>
        <li>5. Dependencia de nuevos inversores para pagar a los existentes</li>
      </ul>
    </>
  );
};
